/** Спроецировать экземпляр в UnitView (свежий объект; vars клонируются). */
export function toUnitView(inst) {
    return {
        id: inst.id,
        seq: inst.seq,
        defId: inst.defId,
        ownerId: inst.ownerId,
        controllerId: inst.controllerId,
        zone: inst.zone,
        ...(inst.cellId !== undefined ? { cellId: inst.cellId } : {}),
        isToken: inst.isToken === true,
        ...(inst.enteredRound !== undefined ? { enteredRound: inst.enteredRound } : {}),
        heat: inst.heat ?? 0,
        freeze: inst.freeze ?? 0,
        ...(inst.hack !== undefined ? { hack: structuredClone(inst.hack) } : {}),
        stats: {
            attack: inst.stats.attack,
            health: inst.stats.health,
            maxHealth: inst.stats.maxHealth,
        },
        vars: structuredClone(inst.vars),
    };
}
/** Спроецировать ячейку в CellView (свежий объект). */
export function toCellView(cell) {
    return {
        id: cell.id,
        tableId: cell.tableId,
        laneIndex: cell.laneIndex,
        side: cell.side,
        occupantId: cell.occupantId,
    };
}
/** Спроецировать игрока в PlayerView (свежий объект; списки зон → счётчики). */
export function toPlayerView(player) {
    return {
        id: player.id,
        side: player.side,
        health: player.health,
        resources: {
            energy: player.resources.energy,
            energyMax: player.resources.energyMax,
            temporaryEnergy: player.resources.temporaryEnergy,
            temporaryEnergyRound: player.resources.temporaryEnergyRound,
        },
        ordinaryTokenDeaths: player.ordinaryTokenDeaths,
        handCount: player.hand.length,
        deckCount: player.deck.length,
        discardCount: player.discard.length,
        armedReactionCount: player.armedReactions.length,
    };
}
/** Спроецировать эффект в EffectView (свежий объект; scope/statMods/vars клонируются). */
export function toEffectView(effect) {
    return {
        id: effect.id,
        seq: effect.seq,
        defId: effect.defId,
        scope: structuredClone(effect.scope),
        ...(effect.sourceId !== undefined ? { sourceId: effect.sourceId } : {}),
        ...(effect.duration !== undefined ? { duration: effect.duration } : {}),
        ...(effect.persistent !== undefined ? { persistent: effect.persistent } : {}),
        ...(effect.statMods !== undefined ? { statMods: structuredClone(effect.statMods) } : {}),
        ...(effect.shield !== undefined ? { shield: structuredClone(effect.shield) } : {}),
        vars: structuredClone(effect.vars),
    };
}
//# sourceMappingURL=views.js.map